import { cn } from "@/lib/utils";

import PawsIcon from "@/assets/svgs/paws.svg?react";
import CalendarIcon from "@/assets/svgs/calendar.svg?react";
import CashRegisterIcon from "@/assets/svgs/cash-register.svg?react";
import HairDryerIcon from "@/assets/svgs/hair-dryer.svg?react";
import BoxIcon from "@/assets/svgs/box.svg?react";
import ReportIcon from "@/assets/svgs/report.svg?react";
import SearchIcon from "@/assets/svgs/search.svg?react";
import MenuIcon from "@/assets/svgs/menu.svg?react";
import UserIcon from "@/assets/svgs/user.svg?react";
import TrashIcon from "@/assets/svgs/trash.svg?react";
import CheckCircleIcon from "@/assets/svgs/check-circle.svg?react";
import CancelCircleIcon from "@/assets/svgs/cancel-circle.svg?react";
import KanbanIcon from "@/assets/svgs/kanban.svg?react";
import LogoIcon from "@/assets/svgs/logo.svg?react";
import LogoMarkIcon from "@/assets/svgs/a-logo.svg?react";
import BedIcon from "@/assets/svgs/bed.svg?react";
import HospitalIcon from "@/assets/svgs/hospital.svg?react";
import { BedSingle, Wallet } from "lucide-react";

export type CustomIconName =
  | "bed"
  | "hospital"
  | "paws"
  | "calendar"
  | "cash-register"
  | "hair-dryer"
  | "box"
  | "report"
  | "search"
  | "menu"
  | "trash"
  | "check-circle"
  | "cancel-circle"
  | "user"
  | "kanban"
  | "logo"
  | "logo-mark"
  | "daycare-hotel"
  | "wallet";

interface CustomIconsProps {
  name: CustomIconName;
  className?: string;
  active?: boolean;
}

type CustomIconsComponentProps = CustomIconsProps &
  Omit<React.SVGProps<SVGSVGElement>, keyof CustomIconsProps>;

const icons: Record<CustomIconName, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  bed: BedIcon,
  hospital: HospitalIcon,
  paws: PawsIcon,
  calendar: CalendarIcon,
  "cash-register": CashRegisterIcon,
  "hair-dryer": HairDryerIcon,
  box: BoxIcon,
  report: ReportIcon,
  search: SearchIcon,
  menu: MenuIcon,
  user: UserIcon,
  trash: TrashIcon,
  "check-circle": CheckCircleIcon,
  "cancel-circle": CancelCircleIcon,
  kanban: KanbanIcon,
  logo: LogoIcon,
  "logo-mark": LogoMarkIcon,
  "daycare-hotel": BedSingle,
  wallet: Wallet,
};

export function CustomIcons({
  name,
  className = "",
  active = false,
  ...svgProps
}: CustomIconsComponentProps) {
  const Icon = icons[name];

  return (
    <Icon
      aria-hidden="true"
      focusable="false"
      className={cn(active ? "text-muted-foreground" : "hover:text-muted-foreground text-muted-foreground/70", className)}
      {...svgProps}
    />
  );
}
